import { useState, useEffect } from "react";
import "./ViewNotes.css";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ViewTable from "../NoteComponents/ViewTable.js";
import Comment from "./Comment.js";
import CloseIcon from "@material-ui/icons/Close";
import {
  Box,
  Checkbox,
  LinearProgress,
  Typography,
  Divider,
} from "@material-ui/core";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  addComment,
  createNoteWithFiles,
  downloadAttachments,
  getNotesData,
  getUserModules,
  getViewNotesData,
} from "../Notes/action";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import GTLabel from "components/GTLabel";
import { Select, MenuItem, ListItemText, FormControl } from "@material-ui/core";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";
import ViewComment from "./ViewComment";

const moduleMapping = {
  1: "E-INV", // E-INV
  2: "E-WB",
  3: "gstr1New", // GSTR-1
  4: "gstr2a2bNew", // GSTR-2A/2B
  5: "gstr3b", // GSTR-3B
  // 6: "Data Analytics",
  7: "Data Fetch",
  8: "gstr9_new", // GSTR-9 (first occurrence)
  9: "Analytics",
  11: "gstr7", // GSTR-7
  12: "itc04", // ITC-04
  13: "gstr6", // GSTR-6
  14: "gstr2X", // GSTR-2X
  15: "gstr8", // GSTR-8
  16: "GtaxPro Tutorials",
  17: "imsReco", // IMS
  18: "EWB-Reco",
};

const useStyles = makeStyles(() => ({
  selectRoot: {
    // size & look of the control
    minWidth: 220,
  },
  icon: {
    color: "#2B144D", // 🔥 your dark purple brand color
    right: 32,
    position: "absolute",
    pointerEvents: "none",
    zIndex: 1400,
  },
  menuPaper: {
    borderRadius: 12,
    maxHeight: 200,
  },
  placeholder: {
    color: "#8A8890", // soft grey for placeholder text
  },
}));
const PillInput = withStyles({
  input: {
    borderRadius: 12,
    width: 150, // ⬅️ control width
    height: 20,
    position: "relative",
    backgroundColor: "#FFFFFF",
    fontSize: 14,
    padding: "12px 40px 12px 16px", // right padding for the icon
    boxShadow: "0 1px 0 rgba(0,0,0,0.06) inset",
    border: "1px solid rgba(0,0,0,0.06)",
    "&:focus": {
      borderRadius: 12,
      borderColor: "#A06DFF", // brand bright purple focus
      boxShadow: "white",
      backgroundColor: "#FFFFFF",
    },
  },
})(InputBase);
function ViewNotes({ open, onClose, viewNotesId,selectedRow,handleSubmit }) {
  const dispatch = useDispatch();
  const [module, setModule] = useState("");
  const { moduleIds } = useSelector((state) => state.notesReducer);
  const { filesData, selectedCategory, notesHeadingData } = useSelector(
    (store) => store.notesReducer
  );
  const {
    loaderStatus,
    tableData,
    entityMasterList,
    defaultEntity,
    profileData,
    selectedGstin: storeSelectedGstin,
    selectedPeriods,
    selectedRowNotes,
    selectedModule: storeSelectedModule,
    selectedCategory: storeSelectedCategory,
    search: storeSearch,
  } = useSelector((store) => store.notesReducer);
  const [selectedOption, setSelectedOption] = useState("");
  const [note, setNote] = useState("");
  const [openViewNote, setOpenViewNote] = useState(false);
  // const [heading, setHeading] = useState("");
  const [openComment, setOpenComment] = useState(false);
  const [selectedFileIds, setSelectedFileIds] = useState([]);
  const isFiledReturn =false
    // (selectedRow && selectedRow.category === "filed_return") ||
    // selectedCategory === "filed_return";

  // heading
  const [content, setContent] = useState("");
  const [previousContent, setPreviousContent] = useState("");
  const styles = {
    container: {
      // border: "1px solid  #A06DFF",
      borderRadius: 8,
      padding: 8,
      // maxWidth: 800,
      backgroundColor: "#fff",
      marginTop: 10,
    },
    header: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: 8,
    },
    row: {
      display: "flex",
      alignItems: "center",
      padding: "8px 12px",
    },
    icon: {
      color: "#4f2d7f",
      fontSize: 32,
      marginRight: 12,
    },
    filename: {
      color: "#4f2d7f",
      fontWeight: 500,
    },
    progressBar: {
      height: 6,
      borderRadius: 4,
      backgroundColor: "#4f2d7f",
    },
  };
  const handleCheckboxChange = (fileId, isChecked) => {
    if (isChecked) {
      // Add the fileId to the selected array if not already present
      setSelectedFileIds((prev) => [...prev, fileId]);
    } else {
      // Remove the fileId from the selected array
      setSelectedFileIds((prev) => prev.filter((id) => id !== fileId));
    }
  };

  const FileRow = ({ name, fileId }) => (
    <>
      <Box style={styles.row}>
        <Checkbox
          color="primary"
          checked={selectedFileIds.includes(fileId)}
          onChange={(e) => handleCheckboxChange(fileId, e.target.checked)}
          // Disable checkbox when this is a Filed Return and style accordingly
          disabled={isFiledReturn}
          style={{
            color: isFiledReturn ? "#9E9E9E" : undefined,
            cursor: isFiledReturn ? "not-allowed" : "pointer",
          }}
          // Prevent native focus on mousedown to avoid browser auto-scrolling
          onMouseDown={(e) => e.preventDefault()}
          // Remove ripple/focus visual that can trigger layout/scroll changes
          disableRipple
          inputProps={{ tabIndex: -1, 'aria-disabled': isFiledReturn }}
        />
        <DescriptionOutlinedIcon style={styles.icon} />
        <Box flex={1}>
          <Typography variant="body1" style={styles.filename}>
            {name}
          </Typography>
          <LinearProgress
            variant="determinate"
            value={100}
            style={styles.progressBar}
          />
        </Box>
      </Box>
      {/* <Divider /> */}
    </>
  );
  // Clear selected files when dialog opens/closes
  useEffect(() => {
    if (!open) {
      setSelectedFileIds([]);
    }
  }, [open]);

  const handleDownloadAttachments = () => {
    if (selectedFileIds?.length === 0) {
      return errorToastMessage("Please select at least one file to download.");
    }
    dispatch(
      downloadAttachments(selectedRow?.category, viewNotesId, selectedFileIds)
    );
  };
  // Custom toolbar options
  const toolbarOptions = [
    [{ header: [1, 2, false] }], // Header options
    ["bold", "italic", "underline"], // Formatting options
    [{ list: "ordered" }, { list: "bullet" }], // Lists
    [{ align: [] }], // Text alignment
    ["clean"], // Remove formatting
  ];

  const modules = {
    toolbar: toolbarOptions, // Toolbar remains the same
  };
  useEffect(() => {
    console.log("content::", content);
    console.log("notesHeadingData::", notesHeadingData);

    // Set initial content from notesHeadingData.heading
    if (notesHeadingData && notesHeadingData.heading) {
      setContent(notesHeadingData.heading);
      setPreviousContent(notesHeadingData.heading); // Initialize previousContent
    } else {
      // Clear content if no comments exist
      setContent("");
      setPreviousContent("");
    }

    // Set default module when notesHeadingData is available
    if (
      notesHeadingData &&
      notesHeadingData.moduleCode &&
      moduleIds?.length > 0
    ) {
      const defaultModuleId = notesHeadingData.moduleCode;
      console.log("Default module from notesHeadingData:", defaultModuleId);

      // Check if the moduleId exists in the available moduleIds
      const moduleExists = moduleIds.some(
        (m) => m.moduleId === defaultModuleId
      );

      if (moduleExists) {
        setModule(defaultModuleId);
        console.log("Set default module to:", defaultModuleId);
      } else {
        console.log("Module not found in available modules:", defaultModuleId);
      }
    }
  }, [notesHeadingData, moduleIds]); // Add moduleIds as dependency
  // Function to filter allowed modules
  const getFilteredModules = (moduleData) => {
    const excludedModuleIds = [1, 2, 6, 7, 9, 16, 18];
    return (
      moduleData?.filter(
        (moduleItem) =>
          !excludedModuleIds.includes(moduleItem.moduleId) &&
          moduleItem.module_name // Also filter out modules without names
      ) || []
    );
  };
  // Module Select Component
  function ModuleSelect({ module, setModule, moduleData, getFilteredModules }) {
    const classes = useStyles();

    // helper to show label by id
    const getLabel = (val) =>
      moduleData?.find((m) => String(m.moduleId) === String(val))
        ?.module_name ?? "";

    const filteredModules = getFilteredModules(moduleData);

    return (
      <FormControl className={classes.selectRoot}>
        <Select
          value={module}
          onChange={(e) => setModule(e.target.value)}
          input={<PillInput />}
          IconComponent={KeyboardArrowDownIcon}
          classes={{ icon: classes.icon }}
          displayEmpty
          renderValue={(selected) => {
            if (
              selected === "" ||
              selected === undefined ||
              selected === null
            ) {
              return <span className={classes.placeholder}>Select Module</span>;
            }
            return getLabel(selected);
          }}
          MenuProps={{
            classes: { paper: classes.menuPaper },
            getContentAnchorEl: null, // better menu positioning in v4
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            transformOrigin: { vertical: "top", horizontal: "left" },
          }}
        >
          <MenuItem value="">
            <em>Select Module</em>
          </MenuItem>
          {filteredModules?.map((moduleItem) => (
            <MenuItem key={moduleItem.moduleId} value={moduleItem.moduleId}>
              {moduleItem.module_name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  // const handleSave = async () => {
  //   await dispatch(addComment(viewNotesId, content));
  //   // await dispatch(getViewNotesData(viewNotesId));
  //   // onClose();
  // };
    // Add this helper function after the isInSameFinancialYear function
  const getPlainTextFromHTML = (htmlString) => {
    // Using DOMParser (most accurate for ReactQuill HTML)
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return doc.body.textContent || doc.body.innerText || "";
  };
  const handleSave = async () => {
    try {
      if (
        !defaultEntity ||
        !storeSelectedGstin ||
        storeSelectedGstin.length === 0 ||
        !module ||
        !selectedPeriods ||
        selectedPeriods.length === 0
      ) {
        errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
        return;
      }

      // if (!note || note.trim() === "") {
      //   errorToastMessage("Please enter note content");
      //   return;
      // }

      // if (!filesData || filesData.length === 0) {
      //   errorToastMessage("Please select at least one file");
      //   return;
      // }
        // Extract plain text from HTML and validate length
            const plainTextContent = getPlainTextFromHTML(content);
            const trimmedPlainText = plainTextContent.trim();
            const plainTextLength = trimmedPlainText.length;
      
            if (!trimmedPlainText || plainTextLength === 0) {
              errorToastMessage("Please enter note content");
              return;
            }
      
            // Add maximum length validation - 2000 characters
            if (plainTextLength > 2000) {
              errorToastMessage(
                `Note content cannot exceed 2000 characters. Current length: ${plainTextLength} characters.`
              );
              return;
            }
          // Get module name from moduleIds array
      const selectedModuleData = moduleIds?.find((m) => m.moduleId === module);
      const moduleName = selectedModuleData?.module_name || "";
      console.log("Selected module name:", moduleName);

    // Get entity name from entityMasterList array (fix: use string comparison)
    const selectedEntityData = entityMasterList?.find(
      (e) => String(e.value) === String(defaultEntity)
    );
    const entityName = selectedEntityData?.label || "";
    console.log("Selected entity name:", entityName);
    console.log('selectedRow::',selectedRow)
      // Prepare note data
      const noteData = {
        moduleCode: module,
        category: selectedRow?.category,
        entityId: defaultEntity,
        entityName: entityName,
        heading: content, // Using note content as heading for now
        // gstin:
        //   storeSelectedGstin && storeSelectedGstin.length > 0
        //     ? storeSelectedGstin[0]
        //     : "", // Single GSTIN selection
        // periods: selectedPeriods,
        gstin: selectedRow?.gstin,
        periods:selectedRow?.periods
      };

      console.log("Saving note with data:", noteData);
      console.log("Files to upload:", filesData);

      // Extract actual File objects from filesData
      const fileObjects = filesData.map((fileData) => fileData.file);

      // Call the API to create note with files
      const result = await dispatch(createNoteWithFiles(noteData, fileObjects));

      if (result) {
        // Close the dialog on successful save
        // dispatch(setOpenAddNotes(false));

        // Refresh the notes data with current filters
        // const currentFilters = {
        //   page: 1,
        //   module: storeSelectedModule || "",
        //   category: storeSelectedCategory || "",
        //   entity: defaultEntity,
        //   gstin: storeSelectedGstin[0] || "",
        //   search: storeSearch || "",
        // };
        //  dispatch(getNotesData(currentFilters));
handleSubmit(false)
        // Clear the form data
        setNote("");
        // setFilesData([]);
        setModule("");
        // setCategory("");

        // Reset file input
        // if (fileInputRef.current) {
        //   fileInputRef.current.value = "";
        // }

        console.log("Note saved successfully:", result);
      }
    } catch (error) {
      console.log("Error in handleSave:", error);
    }
  };
  useEffect(() => {
    dispatch(getUserModules());
  }, []);

  useEffect(() => {
    return () => {
      setSelectedFileIds([]);
    };
  }, []);
  const handleCloseViewNote = () => {
    setOpenViewNote(false);
  };
  return (
    <>
      {/* Main Viewnotes Dialog */}
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div></div>
            <Typography
              variant="h6"
              style={{
                textWrap: "wrap",
                wordBreak: "break-word",
                                fontWeight: "bold",

              }}
            >
              View Notes
            </Typography>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <div
            className="viewnotes-modal"
            style={{
              boxShadow: "none",
              background: "#f9f5ff",

              // padding: 0
            }}
          >
            <div className="line1">
              {/* <div style={{ display: "flex", flexDirection: "column" }}>
                <GTLabel title={"Select Module"} />
                <ModuleSelect
                  module={module}
                  setModule={setModule}
                  moduleData={moduleIds} // Use moduleIds from Redux instead of props.moduleData
                  getFilteredModules={getFilteredModules}
                />
              </div> */}
              <div id="button">
                <div className="btn">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpenComment(true)}
                    style={{
                      backgroundColor: "#4f2d7f",
                      color: "white",
                      textTransform: "capitalize",
                      height: "30px",
                      // padding:'0'
                    }}
                  >
                    Add Comment
                  </Button>
                </div>
                <div className="btn">
                  <Button
                    onClick={handleSave}
                    variant="contained"
                    color="primary"
                    style={{
                      backgroundColor: "#4f2d7f",
                      color: "white",
                      textTransform: "capitalize",
                      height: "30px",
                      marginLeft:'2em',
                      padding:'0px'
                    }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>

            <div className="line2">
              <div className="text-area">
                <ReactQuill
                  value={content}
                  onChange={setContent}
                  theme="snow"
                  modules={modules}
                  placeholder="Write your comment here..."
                />
              </div>
            </div>

            <div className="line3">
              <div id="tt">
                <ViewTable />
              </div>
            </div>

            {/* <div id="download">
              <div className="line4">
                <Button variant="contained" color="primary" style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              textTransform: "capitalize",
              height: "30px",
             
            }}>
                  Download Attachments
                </Button>
              </div>

              <div className="line5">
                <div className="file">
                  <input
                    type="checkbox"
                    onChange={(e) => console.log(e.target.checked)}
                  />
                  <span>File 24-2024</span>
                </div>
                <div className="file">
                  <input
                    type="checkbox"
                    onChange={(e) => console.log(e.target.checked)}
                  />
                  <span>File 24-2024</span>
                </div>
              </div>
            </div> */}
            <Box style={styles.container}>
              <Box style={styles.header}>
                <Button
                  variant="contained"
                  onClick={handleDownloadAttachments}
                  disabled={isFiledReturn}
                  style={{
                    backgroundColor: isFiledReturn ? "#F0F0F0" : "#4f2d7f",
                    color: isFiledReturn ? "#9E9E9E" : "#FFFFFF",
                    textTransform: "Capitalize",
                    cursor: isFiledReturn ? "not-allowed" : "pointer",
                    boxShadow: isFiledReturn ? "none" : undefined,
                    border: isFiledReturn ? "1px solid #E0E0E0" : undefined,
                  }}
                >
                  Download Attachment
                </Button>
              </Box>
              <div
                style={{
                  maxHeight: 300,
                  overflowY: "auto",
                  paddingRight: 8,
                }}
                // prevent wheel propagation so parent dialog doesn't react
                onWheel={(e) => e.stopPropagation()}
              >
                {filesData.map((file) => (
                  <FileRow
                    key={file.FILE_ID}
                    name={file.ORIGINAL_FILE_NAME}
                    fileId={file.FILE_ID}
                  />
                ))}
              </div>
            </Box>
          </div>
        </DialogContent>
      </Dialog>

      <Comment
        open={openComment}
        onClose={() => setOpenComment(false)}
        modules={modules}
        viewNotesId={viewNotesId}
      />
    </>
  );
}

export default ViewNotes;
